import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { getCityName } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import Box from "@mui/material/Box";


function createData(
  id,
  nrkcode,
  createdat,
  startdate,
  city,
  driverdetails,
  type,
  status,
  NRK,
) {
  return {
    id,
    nrkcode,
    createdat,
    startdate,
    city,
    driverdetails,
    type,
    status,
    NRK,
  };
}

const Nonrevenuekm = ({ selectedRow }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const nrkStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.nrkStatus;
  const [totalCount, setTotalCount] = useState(0);
  const [nrkDetails, setNRKDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState({});
  const [vehicleId, setVehicleId] = useState(null);

  const getCityNameAPI = async (id) => {
    const apiDetails = await getCityName(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setCities(response);
    }
  };

  useEffect(() => {
    getCityNameAPI();
  }, [selectedRow]);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 100,
      align: "start",
      sortable: false,
    },
    {
      field: "nrkcode",
      headerName: "NRK Code",
      minWidth: 170,
      align: "start",
      sortable: false,
    },
    {
      field: "createdat",
      headerName: "Created At",
      minWidth: 200,
      align: "start",
      sortable: false,
    },
    {
      field: "startdate",
      headerName: "Start Date",
      minWidth: 150,
      align: "start",
    },
    // { field: "city", headerName: "City", minWidth: 150, align: "start" },
    {
      field: "driverdetails",
      headerName: "Driver Details",
      minWidth: 250,
      align: "start",
      sortable: false,
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 200,
      align: "start",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      align: "start",
    },
    {
      field: "NRK",
      headerName: "NRK",
      minWidth: 200,
      align: "start",
      renderCell: (params) => (
        <Box
          sx={{
            color: "#ff3131",
            fontWeight: 700,
            py: 0.5,
          }}
        >
          {params.value || "-"}
        </Box>
      ),
    },
  ];

  const rows =
    (nrkDetails &&
      nrkDetails?.map((item) =>
        createData(
          item?.id,
          item?.tripCode,
          formatDateAndTime(item?.createdAt),
          formatDateAndTime(item?.tripStart),
          cities[item?.cityId] || "-",
          item?.driverName + "/" + item?.driverEmail,
          item?.tripReason,
          nrkStatus[item?.nrkStatus],
          item?.totalDistance,
        ),
      )) ||
    [];

  const getVechileListings = async (page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/nonrevenuekilometers?limit=${limit}&offset=${offset}&vehicleId=${vehicleId}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setNRKDetails(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vehicleId) {
      getVechileListings(paginationModel.page, paginationModel.pageSize);
    }
  }, [vehicleId, paginationModel]);

  useEffect(() => {
    if (selectedRow) {
      setVehicleId(selectedRow.id);
    }
  }, [selectedRow]);

  return (
    <>
      <Commongrid
        rows={rows}
        columns={columns}
        totalCount={totalCount} // total rows from API
        handleViewClick={() => {}}
        api={getVechileListings}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
        loading={loading}
        disableColumnMenu={false}
      />
    </>
  );
};

export default Nonrevenuekm;
